// Generate Mechanic Reports

export const GENERATE_MECHANIC_REPORTS_REQUEST =
  'GENERATE_MECHANIC_REPORTS_REQUEST';
export const GENERATE_MECHANIC_REPORTS_SUCCESS =
  'GENERATE_MECHANIC_REPORTS_SUCCESS';
export const GENERATE_MECHANIC_REPORTS_FAIL = 'GENERATE_MECHANIC_REPORTS_FAIL';

// Get Mechanic Reports

export const GET_MECHANIC_REPORTS_REQUEST = 'GET_MECHANIC_REPORTS_REQUEST';
export const GET_MECHANIC_REPORTS_SUCCESS = 'GET_MECHANIC_REPORTS_SUCCESS';
export const GET_MECHANIC_REPORTS_FAIL = 'GET_MECHANIC_REPORTS_FAIL';

// Get All Order Reports

export const GET_ALL_ORDER_REPORTS_REQUEST = 'GET_ALL_ORDER_REPORTS_REQUEST';
export const GET_ALL_ORDER_REPORTS_SUCCESS = 'GET_ALL_ORDER_REPORTS_SUCCESS';
export const GET_ALL_ORDER_REPORTS_FAIL = 'GET_ALL_ORDER_REPORTS_FAIL';
export const CLEAR_ALL_ORDER_REPORTS_STATES = 'CLEAR_ALL_ORDER_REPORTS_STATES';

// Get Sale Summary Reports

export const GET_SALE_SUMMARY_REPORTS_REQUEST =
  'GET_SALE_SUMMARY_REPORTS_REQUEST';
export const GET_SALE_SUMMARY_REPORTS_SUCCESS =
  'GET_SALE_SUMMARY_REPORTS_SUCCESS';
export const GET_SALE_SUMMARY_REPORTS_FAIL = 'GET_SALE_SUMMARY_REPORTS_FAIL';
export const CLEAR_SALE_SUMMARY_REPORTS_STATES =
  'CLEAR_SALE_SUMMARY_REPORTS_STATES';

// ========= Day End Report Start ==================
// Get Header Matrices
export const GET_HEADER_MATRICES_REQUEST = 'GET_HEADER_MATRICES_REQUEST';
export const GET_HEADER_MATRICES_SUCCESS = 'GET_HEADER_MATRICES_SUCCESS';
export const GET_HEADER_MATRICES_FAIL = 'GET_HEADER_MATRICES_FAIL';

// Get First table Day End
export const GET_DAY_END_FIRST_TABLE_REQUEST =
  'GET_DAY_END_FIRST_TABLE_REQUEST';
export const GET_DAY_END_FIRST_TABLE_SUCCESS =
  'GET_DAY_END_FIRST_TABLE_SUCCESS';
export const GET_DAY_END_FIRST_TABLE_FAIL = 'GET_DAY_END_FIRST_TABLE_FAIL';

// Get Second table Day End
export const GET_DAY_END_SECOND_TABLE_REQUEST =
  'GET_DAY_END_SECOND_TABLE_REQUEST';
export const GET_DAY_END_SECOND_TABLE_SUCCESS =
  'GET_DAY_END_SECOND_TABLE_SUCCESS';
export const GET_DAY_END_SECOND_TABLE_FAIL = 'GET_DAY_END_SECOND_TABLE_FAIL';
// ========= Day End Report End ==================

// ========= Sale Summary Report ==================
// Get Sale Summary Report
export const GET_SALE_SUMMARY_REPORT_REQUEST =
  'GET_SALE_SUMMARY_REPORT_REQUEST';
export const GET_SALE_SUMMARY_REPORT_SUCCESS =
  'GET_SALE_SUMMARY_REPORT_SUCCESS';
export const GET_SALE_SUMMARY_REPORT_FAIL = 'GET_SALE_SUMMARY_REPORT_FAIL';

// Share report Pdf
export const SHARE_REPORT_PDF_REQUEST = 'SHARE_REPORT_PDF_REQUEST';
export const SHARE_REPORT_PDF_SUCCESS = 'SHARE_REPORT_PDF_SUCCESS';
export const SHARE_REPORT_PDF_FAIL = 'SHARE_REPORT_PDF_FAIL';

// ========= All Payment Report ==================
export const GET_ALL_PAYMENT_REPORT_REQUEST = 'GET_ALL_PAYMENT_REPORT_REQUEST';
export const GET_ALL_PAYMENT_REPORT_SUCCESS = 'GET_ALL_PAYMENT_REPORT_SUCCESS';
export const GET_ALL_PAYMENT_REPORT_FAIL = 'GET_ALL_PAYMENT_REPORT_FAIL';

// ========= Payment Summary Report ==================
export const GET_PAYMENT_SUMMARY_REPORT_REQUEST =
  'GET_ALL_PAYMENT_REPGET_PAYMENT_SUMMARY_REPORT_REQUESTORT_REQUEST';
export const GET_PAYMENT_SUMMARY_REPORT_SUCCESS =
  'GET_PAYMENT_SUMMARY_REPORT_SUCCESS';
export const GET_PAYMENT_SUMMARY_REPORT_FAIL =
  'GET_PAYMENT_SUMMARY_REPORT_FAIL';

// ========= Account RecieveAble Report ==================
export const GET_ACCOUNT_RECIEVABLE_REPORT_REQUEST =
  'GET_ACCOUNT_RECIEVABLE_REPORT_REQUEST';
export const GET_ACCOUNT_RECIEVABLE_REPORT_SUCCESS =
  'GET_ACCOUNT_RECIEVABLE_REPORT_SUCCESS';
export const GET_ACCOUNT_RECIEVABLE_REPORT_FAIL =
  'GET_ACCOUNT_RECIEVABLE_REPORT_FAIL';
